export const parseDomainName = (domainName: string) => {
  return domainName.startsWith("www.") ? domainName.slice(4) : domainName;
};
